import React from 'react';
import ReactDOM from 'react-dom';
import LoginPage from 'components/LoginPage';
import g11n from 'hudl-g11n';
import { data } from 'hudl-base';
import { BrowserRouter as Router } from 'react-router-dom';
import ErrorBoundary from 'components/shared/ErrorBoundary';

const IntlProvider = g11n.ReactIntl.IntlProvider;
const i18n = {
  locale: data.get('i18nLocale'),
  messages: data.get('i18nMessages'),
};

ReactDOM.render(
  <IntlProvider {...i18n}>
    <ErrorBoundary>
      <Router>
        <LoginPage />
      </Router>
    </ErrorBoundary>
  </IntlProvider>,
  document.getElementById('app'),
);
